import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const ar = {
  IBCorporate: 'وسيط مُعرِفّ شركة',
  IBIndividual: 'وسيط مُعرِفّ فردي',
  MAMIndividual: 'MAM Individual',
  MAMMasterWithLPOA: 'MAM Individual',
  MarkupConfirmation: 'Markup Confirmation',
  UserCorporate: 'مستخدم شركة',
  UserIndividual: 'مستخدم فردي',
  UserJoint: 'مستخدم مشترك',
  account: {
    bankingDetails: 'البيانات البنكية',
    createANewAccount: 'إنشاء حساب جديد',
    register: 'تسجيل',
    registerSignInTitle: 'هل أنت عضو بالفعل؟',
  },
  admin: {
    user: {
      fields: {
        isMam: 'هو MAM',
        isSales: 'مستخدم مبيعات',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'تقرير FTD_UTM',
        menuTitle: 'تقرير FTD_UTM',
      },
    },
  },
  adminSocialTrading: {
    title: 'التداول الاجتماعي',
    investorAccountDetails: {
      tradingAccountName: 'اسم حساب التداول',
      balance: 'الرصيد',
      login: 'تسجيل الدخول',
    },
    masterAccountDetails: {
      copyType: 'نوع النسخ',
      groupMappingType: 'Group Mapping Type',
      login: 'تسجيل الدخول',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: 'Collect your Birthday gift',
    availableTable: {
      bonusSize: 'Bonus Size',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: 'Record was not found',
    },
    captcha: {
      captchaServerIsUnavailable:
        'خادم Captcha غير متاح. يرجى تحديث الصفحة والمحاولة مرة أخرى. إذا استمرت المشكلة، يرجى الاتصال بفريق الدعم عبر الدردشة الحية أو البريد الإلكتروني {{0}}',
    },
    files: {
      fileWasNotUploaded: 'تعذر تحميل الملف',
    },
    mam: {
      linkIsInactive: 'الرابط المستخدم غير نشط',
    },
    trading: {
      profitSharingLimitWasExceeded: 'يرجى ملاحظة أنه تم تجاوز الحد الأقصى لمشاركة الأرباح. الحد الأقصى هو {{0}}%.',
      notEnoughMoney:
        'We apologize, but you do not have enough funds in your trading account to process the requested withdrawal. Please ensure that you have a sufficient balance available before attempting a withdrawal. Please note that in addition to the available balance, you should also consider the free margin level required for withdrawals.',
    },
    copyTrading: {
      equityIsLessOrEqualZero: 'The Master account is ineligible to be copied at this time, please try again later.',
    },
    securityCode: {
      emptyValue: 'The entered security value (password or PIN code) cannot be empty or null',
      invalidLength: 'The entered security value (password or PIN code) must contain {{0}} character(s)',
      invalidMinLength: 'The entered security value (password or PIN code) must contain at least {{0}} character(s)',
      invalidMaxLength: 'The entered security value (password or PIN code) must not exceed {{0}} character(s)',
      manyRepeatedValues:
        'The entered security value (password or PIN code) must not have more than {{0}} repeated character(s)',
      missingNumericValues: 'The entered security value (password or PIN code) must contain numeric character(s)',
      containsNumericValues: 'The entered security value (password or PIN code) must not contain any numeric values',
      missingLowerCaseValues: 'The entered security value (password or PIN code) must contain lowercase character(s)',
      containsLowerCaseValues:
        'The entered security value (password or PIN code) must not contain any lowercase values',
      missingUpperCaseValues: 'The entered security value (password or PIN code) must contain uppercase character(s)',
      containsUpperCaseValues:
        'The entered security value (password or PIN code) must not contain any uppercase values',
      missingSpecialValues: 'The entered security value (password or PIN code) must contain special character(s)',
      containsSpecialValues:
        'The entered security value (password or PIN code) must not contain any special characters',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: 'Sorry for the inconvenience, but the account {{0}} has been disabled',
      ageIsAboveMaxAllowed: 'We do not accept applications from anyone under {{0}} or over {{1}} years old.',
      ageIsUnderMinAllowed: 'We do not accept applications from anyone under {{0}} years old.',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: 'Field {{0}} is required',
      ibCodeIsIncorrect: "The IB code '{{0}}' is incorrect. Please enter a valid IB code",
      invalidCredentials: 'Invalid username {{0}} and/or password',
      invalidLengthOfPhoneNumber: 'The phone number length is invalid, please try again',
      invalidLink: 'The link is invalid',
      invalidPhoneNumberLength: 'The phone number length is invalid, please try again',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {{0}} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Only latin characters and digits can be used for {{0}} field',
      onlyLatinCharactersCanBeUsed: 'Only latin characters can be used for {{0}} field',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: "User {{0}} doesn't exist",
      userEmailAlreadyExists: 'User email has been already registered in the system',
      userPhoneAlreadyExists: 'User phone has been already registered in the system',
      cantUpdateProfileActualStatus: '{{تعذر تحديث الحساب {{0}}الحالة الفعلية = {{1',
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'أو اسحب ملفاتك هنا',
    exportFormat: 'تنسيق ملف التصدير',
    getCode: 'احصل على رمز',
    hide: 'إخفاء',
    limitMessage: '{{limit}} أحرف متبقية',
    resend: 'إعادة إرسال',
    seconds: 'ثانية',
    show: 'عرض',
  },
  headerWithBalance: {
    serverTime: 'توقيت الخادم',
    failedToFetchServerTime: 'تعذر إحضار توقيت الخادم',
    view: 'عرض',
  },
  investors: {
    blackList: 'القائمة السوداء',
  },
  legal: {
    clientAgreement: 'اتفاقية العميل',
    privacyPolicy: 'سياسة الخصوصية',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: 'عن الأستاذ',
    infoFields: {
      ibCode: 'رمز الوسيط المُعرِفّ',
    },
  },
  masters: {
    fields: {
      masterNickname: 'لقب الأستاذ',
      rating: 'المركز في جدول الترتيب',
    },
  },
  menu: {
    deposit: 'الإيداع',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked: "بدأ حساب المتابِع في النسخ من حساب الأستاذ '{{MasterAccountName}}'.",
      InvestorAccountWasOpened:
        "تم إنشاء حساب المتابِع. بدأ حساب المتابِع في النسخ من حساب الأستاذ '{{InvestorAccountName}}'.",
      InvestorAccountWasUnlinked: "توقف حساب المتابِع عن النسخ من حساب الأستاذ '{{MasterAccountName}}'.",
      MasterAccountWasChanged:
        'تم تعديل حساب الأستاذ. (مشاركة الأرباح = {{ProfitSharing}}، طريقة التخصيص = {{AllocationMethod}})',
      MasterAccountWasLinked: "بدأ حساب المتابِع '{{InvestorAccountName}}' في النسخ من حساب الأستاذ.",
      MasterAccountWasOpened:
        'تم إنشاء حساب الأستاذ. (مشاركة الأرباح = {{ProfitSharing}}، طريقة التخصيص = {{AllocationMethod}})',
      MasterAccountWasUnlinked: "توقف حساب المتابِع '{{InvestorAccountName}}' عن النسخ من حساب الأستاذ.",
    },
  },
  modal: {
    error: 'خطأ',
    notification: 'إشعار',
    ok: 'موافق',
  },
  operationHistory: {
    filterName: 'بحث',
    placeholder: 'يرجى إدخال',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'المبيعات',
    ibInfo: {
      detailsTitle: 'تفاصيل الوسيط المُعرِفّ',
      nextRebatePayment: 'دفعة الحسومات التالية',
      statistics: {
        closetTradersReport: {
          type: 'النوع',
        },
        tradingVolReport: {
          subIb: 'الوسيط المُعرِفّ الفرعي',
        },
      },
    },
    ibSettings: {
      referralLinkError: 'العلاوة غير صحيح! يرجى الاتصال بفريق الدعم للحصول على العلاوات الصحيحة',
    },
    salesUserInfo: {
      aeCode: 'كود AE',
    },
  },
  profile: {
    adult: 'عمري أكثر من 18 سنة',
    code: 'الرمز',
    country: 'الدولة',
    documentsUploaded: 'الوثائق المرفوعة',
    isAgreeWithTermsAndConditions: 'أوافق على <0> اتفاقية العميل </0> و <1> سياسة الخصوصية </1>',
    pleaseValidateAccountToDeposit:
      'يجب أن يتحقق فريق الامتثال التنظيمي لدى {{brokerName}} من بياناتك الشخصية. قبل البدء في عملية الإيداع، يجب إرسال صورة ممسوحة ضوئيًا من بطاقة هويتك.',
    successChangeDescription: 'تم حفظ التغييرات!',
    warningMessage: {
      profileIsBeingVerified: 'جارِ التحقق من ملفك الشخصي، قد يستغرق الأمر بضع ثوانٍ',
    },
  },
  psp: {
    accountsFetchFailErr: 'تعذر إحضار الحسابات',
    confirmEveryTransaction: 'قد تستغرق عمليات الإيداع ما يصل إلى 24 ساعة حتى الانتهاء من تأكيد جميع المعاملات.',
    deposit: {
      depositForm: {
        accountNameTitle: 'أسم الحساب',
        addressLine2: 'سطر العنوان 2',
        beneficiaryAccountNumberTitle: 'رقم حساب المستفيد',
        beneficiaryBankHint: 'يُرجى تحديد رقم الحساب المصرفي',
        beneficiaryBankNameHint: 'اسم البنك، على سبيل المثال (Standard Charted Bank)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: 'يرجى إرفاق مستند يؤكد عملية الدفع إذا لزم الأمر',
      },
      depositTitle: 'إيداع الأموال',
      notice: 'يُسمح بإجراء الإيداعات فقط للحسابات التي تم التحقق منها',
      warnToSubmitPersonalDetails:
        'لإجراء الإيداع، يرجى تقديم بياناتك الشخصية، تأكد من أن هذه البيانات تتطابق مع تلك المذكورة في بطاقة هويتك',
    },
    localAgentTable: {
      login: 'تسجيل الدخول',
    },
    operationsFetchFailErr: 'تعذر إحضار العمليات',
    operationsTable: {
      documentTitle: 'الوثيقة',
      operationsTableTitle: 'العمليات الأخيرة',
      paymentSystemTitle: 'نظام الدفع',
    },
    pluginInfoFetchFailErr: 'تعذر إحضار معلومات البرنامج الإضافي',
    pluginNotFound: 'البرنامج الإضافي غير موجود',
    pluginsFetchFailErr: 'تعذر إحضار البرامج الإضافية',
    preAuthorizedBanking: 'الخدمات المصرفية المُصرح بها مسبقًا',
    qrCodeCryptoNotice:
      'رمز الاستجابة السريعة متاح للاستخدام لمرة واحدة فقط. لا تمسح هذا الرمز ضوئيًا في تطبيق العملات المشفرة أكثر من مرة، وإلا سيتم تعليق دفعتك.',
    qrCodeCryptoTitle: 'رمز الاستجابة السريعة لتطبيق العملات المشفرة',
    resentOperationsTitle: 'العمليات الأخيرة',
    transfer: {
      transactionDetailsTitle: 'تفاصيل المعاملة',
      transferForm: {
        amountError: 'تم تجاوز مبلغ التحويل المتاح',
        currencyTitle: 'العملة',
      },
    },
    uploadBankStatementWithBankName: 'قم بتحميل كشف حساب بنكي يحتوي على اسم البنك واسمك الكامل ورقم حسابك المصرفي',
    uploadPayslip: 'قم بتحميل إيصال الدفع الخاص بإيداعك الصادر من البنك',
    uploadYourDocument: 'يرجى تأكيد إيداعك عن طريق تحميل صورة من كشف حسابك البنكي',
    withdrawal: {
      notice: 'عمليات السحب متاحة فقط للحسابات التي تم التحقق منها',
      withdrawalTitle: 'سحب الأموال',
      withdrawalForm: {
        bankNameTitle: 'اسم البنك',
        beneficiaryCryptoWalletHint: 'سيتم إرسال رقم المحفظة التي ستُرسل العملات المشفرة إليها',
        beneficiaryCryptoWalletTitle: 'محفظة العملات المشفرة للمستفيد',
        confirmTitle: 'تأكيد معلومات السحب',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: 'تحقق مما إذا كان رقم التعريف هو نفسه الموجود في الصورة',
      documentTypeHint: 'يرجى التأكد من إرسال صورة عالية الجودة أو مسح الوثيقة ضوئيًا.',
      uploadedDocumentsTable: {
        docNameTitle: 'اسم الملف',
        documentNumber: 'رقم الوثيقة',
        typeTitle: 'نوع الوثيقة',
      },
    },
    profileForm: {
      editProfileTitle: 'تعديل الملف الشخصي',
      proceedToDeposit: 'متابعة الإيداع',
      saveUserSuccessMessage: 'تم حفظ الملف الشخصي بنجاح',
      userDetailsErrorMessage: 'تعذر إحضار الملف الشخصي للمستخدم',
      verifyPersonalDetails: 'تحقق من التفاصيل الشخصية',
      verifyProfileBtn: 'تحقق من الملف الشخصي',
    },
  },
  socialTradingModal: {
    copyHint: 'سيتوقف حسابك {{account}} عن النسخ من حساب الأستاذ {{oldMaster}}، وسيبدأ في النسخ من {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'حساب التداول',
    accountHistoryForm: {
      closeTimeTitle: 'وقت الإغلاق',
    },
    changeTradingAccountName: 'تغيير اسم حساب التداول',
    connectedAccounts: 'الحسابات المتصلة',
    currency: 'العملة',
    depositForm: {
      amountTitle: 'المبلغ',
      errorMessage: 'فشل إيداع الأموال',
      successMessage: 'تم الإيداع بنجاح',
    },
    descriptionPlaceholder: 'ادخِل توصية لمتابعيك',
    fetchServersErr: 'تعذر إحضار الخوادم',
    ibCode: 'الوسيط المُعرِفّ (اختياري)',
    notRows: 'لا توجد صفوف لعرضها',
    openAccountModalSubTitle: 'أكبر مجموعة من أدوات التداول: العملات والمعادن. شروط التداول القياسية.',
    tradingPlatforms: 'منصات التداول',
    transferForm: {
      title: 'تحويل الأموال',
    },
    withdrawForm: {
      amountTitle: 'المبلغ',
      errorMessage: 'فشل في حفظ الرافعة المالية',
      successMessage: 'تم السحب بنجاح',
    },
  },
} satisfies ILocaleLegacy;
